import React, { useState } from "react";
import {
  Box,
  Grid,
  ImageList,
  ImageListItem,
  MenuItem,
} from "@mui/material";
import InputTextField from "../../../../components/input/inputTextField";
import FilterSelect from "../../../../components/select/filterSelect";
import { ROOM_MEETING_TYPE } from "../../../../constants/enum";
import ImageTracking from "../../../../components/upload/MultiUploadFile";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

type Props = {
  formMeetingRoom: any;
  setFormMeetingRoom: any;
  coverImage: any;
  setCoverImage: any;
  contentImage: any;
  setContenImage: any;
  existingCoverImages: any;
  existingContentImages: any;
  isActive?: boolean;
  handleDeleteImageApiCoverImage?: (id_file: number) => void;
  handleDeleteImageApiContentImages?: (id_file: number) => void;
  view?: boolean;
  hidden_upload_image?: boolean;
  hidden_meeting_type?: boolean;
}
export default function RoomMeetingDetail(props: Props) {
  const {
    formMeetingRoom,
    setFormMeetingRoom,
    coverImage,
    setCoverImage,
    contentImage,
    setContenImage,
    existingCoverImages,
    existingContentImages,
    isActive,
    view,
    hidden_upload_image,
    hidden_meeting_type,
    handleDeleteImageApiCoverImage,
    handleDeleteImageApiContentImages
  } = props;
  const base_image = useSelector((state: RootState) => state.api.image_api);
  const [meetingType, setMeetingType] = useState<any[]>([
    {
      id_meeting_type: ROOM_MEETING_TYPE.CLASS_ROOM,
      meeting_type_name: ROOM_MEETING_TYPE.CLASS_ROOM,
    },
    {
      id_meeting_type: ROOM_MEETING_TYPE.MEETING_ROOM,
      meeting_type_name: ROOM_MEETING_TYPE.MEETING_ROOM,
    },
  ]);

  const handleDeleteImageUploadFileCover = (index: number) => {
    setCoverImage((prev: any) =>
      prev.filter((_: any, i: number) => i !== index)
    );
  };

  const handleDeleteImageUploadFileContent = (index: number) => {
    setContenImage((prev: any) =>
      prev.filter((_: any, i: number) => i !== index)
    );
  };

  const handleChangeImageCover = (newFile: any) => {
    const newArray = Array.isArray(newFile) ? newFile : [newFile];

    if (newFile?.length > 0) {
      setCoverImage((prev: any) => [...prev, ...newArray]);
    } else {
      setCoverImage((prev: any) => [...prev, newFile]);
    }
  };

  const handleChangeContentImage = (newFile: any) => {
    const newArray = Array.isArray(newFile) ? newFile : [newFile];
    if (newFile?.length > 0) {
      setContenImage((prev: any) => [...prev, ...newArray]);
    } else {
      setContenImage((prev: any) => [...prev, newFile]);
    }
  };

  return (
    <section className="w-full mt-10">
      <Grid container spacing={2}>
        {!hidden_meeting_type && (
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <FilterSelect
              heading="ประเภทห้อง"
              labelId="year-id"
              selectId="year-select-id"
              required
              options={meetingType.map((item: any, index: number) => (
                <MenuItem value={item.id_meeting_type} key={index + 1}>
                  {item.meeting_type_name}
                </MenuItem>
              ))}
              placeholder="ระบุประเภทห้อง"
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormMeetingRoom({
                  ...formMeetingRoom,
                  id_meeting_type: e.target.value,
                });
              }}
              value={formMeetingRoom?.id_meeting_type || ""}
              disabled={view}
            />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={12}
          lg={9}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={"ชื่อการประชุม"}
            placeholder={"ชื่อการประชุม"}
            required
            value={formMeetingRoom?.meeting_room_name}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_name: e.target.value,
              });
            }}
            helperText={""}
            disabled={view}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={3}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={"จำนวนที่สามารถรองรับได้ (คน)"}
            placeholder={"จำนวนที่สามารถรองรับได้ (คน)"}
            value={formMeetingRoom?.meeting_room_limit_person}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_limit_person: e.target.value,
              });
            }}
            helperText={""}
            disabled={view}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={"ข้อมูลสถานที่จัดประชุม"}
            placeholder={"ข้อมูลสถานที่จัดประชุม"}
            value={formMeetingRoom?.meeting_room_location}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_location: e.target.value,
              });
            }}
            helperText={""}
            disabled={view}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={"ค่าบริการสำหรับบุคคลภายนอก สกุลเงิน (THB) / วัน"}
            placeholder={"ค่าบริการสำหรับบุคคลภายนอก สกุลเงิน (THB) / วัน"}
            type="number"
            value={formMeetingRoom?.meeting_room_internal_service_fees}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_internal_service_fees: e.target.value,
              });
            }}
            helperText={""}
            disabled={view}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={"ค่าบริการสำหรับบุคคลภายนอก สกุลเงิน (USD) / วัน"}
            placeholder={"ค่าบริการสำหรับบุคคลภายนอก สกุลเงิน (USD) / วัน"}
            value={formMeetingRoom?.meeting_room_external_service_fees}
            type="number"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                meeting_room_external_service_fees: e.target.value,
              });
            }}
            helperText={""}
            disabled={view}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={"อีเมลผู้รับเรื่อง"}
            placeholder={"ระบุอีเมลผู้รับเรื่อง"}
            value={formMeetingRoom?.room_meeting_email}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({
                ...formMeetingRoom,
                room_meeting_email: e.target.value,
              });
            }}
            // helperText={!validateEmail(formMeetingRoom?.room_meeting_email) ? "รูปแบบอีเมลไม่ถูกต้อง" : ""}
            disabled={view}
          />
        </Grid>


        {!hidden_upload_image && (
          <>
            {!isActive ? (
              <>
                {/*  */}
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  sx={{
                    alignSelf: "end",
                  }}
                >
                  <ImageTracking
                    heading="ภาพหน้าปก"
                    handleDeleteImageApi={(_, _D, data) => handleDeleteImageApiCoverImage?.(data?.id)}
                    handleDeleteImageSelect={(_, file_index) =>
                      handleDeleteImageUploadFileCover(file_index)
                    }
                    base_image_url_api={base_image?.replace(/\/$/, "")}
                    onChange={handleChangeImageCover}
                    tabIndex={1}
                    valueAddFile={coverImage}
                    valueImage={existingCoverImages}
                  />
                </Grid>
                {/*  */}
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  sx={{
                    alignSelf: "end",
                  }}
                >
                  <ImageTracking
                    disabled={view}
                    heading="ภาพรายละเอียดภายในห้อง"
                    handleDeleteImageApi={(_, _D, data) => handleDeleteImageApiContentImages?.(data?.id)}
                    handleDeleteImageSelect={(_, file_index) =>
                      handleDeleteImageUploadFileContent(file_index)
                    }
                    base_image_url_api={base_image?.replace(/\/$/, "")}
                    onChange={handleChangeContentImage}
                    tabIndex={2}
                    valueAddFile={contentImage}
                    valueImage={existingContentImages}
                  />
                </Grid>
              </>
            ) : (
              <div
                style={{
                  padding: 12,
                }}
              >
                <p>ภาพหน้าปก</p>
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: 2,
                    marginBottom: 3,
                  }}
                >
                  <ImageList
                    sx={{ width: "100%", height: 200 }}
                    cols={8}
                    rowHeight={164}
                  >
                    {existingCoverImages.map((item: any) => (
                      <ImageListItem key={item.img}>
                        <img
                          srcSet={`${base_image}${item.file_path}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                          src={`${base_image}${item.file_path}?w=164&h=164&fit=crop&auto=format`}
                          alt={item.file_name}
                          loading="lazy"
                          style={{
                            margin: "0px 16px",
                          }}
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </Box>

                <p>ภาพรายละเอียดภายในห้อง</p>
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: 2,
                    marginBottom: 3,
                  }}
                >
                  <ImageList
                    sx={{ width: "100%", height: 200 }}
                    cols={8}
                    rowHeight={164}
                  >
                    {existingContentImages.map((item: any) => (
                      <ImageListItem key={item.img}>
                        <img
                          srcSet={`${base_image}${item.file_path}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                          src={`${base_image}${item.file_path}?w=164&h=164&fit=crop&auto=format`}
                          alt={item.file_name}
                          loading="lazy"
                          style={{
                            padding: "0px 12px",
                          }}
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </Box>
              </div>
            )}
          </>
        )}
      </Grid>
    </section>
  );
}
